import { Autocomplete, TextField } from '@mui/material';
import { CLOUD_PROVIDER } from '@vy/connact';
import { isNotNullOrUndefined, values } from '@vy/utils';
import { Control, Controller } from 'react-hook-form';
import { NewCustomer, UpdateCustomer } from '@vy/types';
import { FC } from 'react';

interface MarketplaceDropdownProps {
    control: Control<NewCustomer | UpdateCustomer>;
}

export const MarketplaceDropdown: FC<MarketplaceDropdownProps> = ({ control }) => {
    const marketplaceOptions = values(CLOUD_PROVIDER);

    return (
        <Controller
            control={control}
            name="settings.cloudProviderSettings.cloudProvider"
            render={({ field, fieldState }) => (
                <Autocomplete
                    options={marketplaceOptions}
                    getOptionLabel={(option) => option}
                    value={field.value ?? null}
                    onChange={(_, newValue) => {
                        field.onChange(newValue);
                    }}
                    onBlur={field.onBlur}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Marketplace"
                            placeholder="Select Marketplace"
                            error={isNotNullOrUndefined(fieldState.error)}
                            helperText={fieldState.error?.message}
                            slotProps={{
                                ...params.slotProps,

                                inputLabel: {
                                    shrink: true,
                                }
                            }}
                        />
                    )}
                />
            )}
        />
    );
};